import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FilterIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.56 9.4L14.6 13.56L14.1 19.96H9.9L9.4 13.56L5.44 9.4C4.66 8.58 4.06 7.28 4.06 5.78V3.96H19.94V5.78C19.94 7.28 19.34 8.58 18.56 9.4ZM11.42 18.36H12.58L12.84 12.86L17.18 8.28C17.66 7.76 18.24 6.88 18.14 5.76H5.86C5.76 6.88 6.34 7.76 6.82 8.28L11.16 12.86L11.42 18.36Z" />
    </SvgIcon>
  );
});
